"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityCreateButton = exports.EntityCreateButtonDefaultProps = void 0;
var React = __importStar(require("react")); // tslint:disable-line
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var router_1 = require("@reach/router");
var route_1 = require("../../utils/route");
var use_lang_1 = require("../../hooks/use-lang");
var use_entity_definition_named_1 = require("../../hooks/use-entity-definition-named");
var current_user_can_1 = require("../../utils/current-user-can");
var icon_button_1 = require("../elements/icon-button");
var sprintf_js_1 = require("sprintf-js");
var use_modal_1 = require("../../hooks/use-modal");
var entity_create_dialog_1 = require("./entity-create-dialog");
exports.EntityCreateButtonDefaultProps = {
  isLabelShown: true,
  params: ''
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var DialogStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\n  "], ["\n\n  "])))
});
// -------- Components -------->
var My = {
  Container: (0, styled_components_1.default)(icon_button_1.CreateIconButton)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  CreateDialog: (0, styled_components_1.default)(entity_create_dialog_1.EntityCreateDialog)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), DialogStyles)
};
var EntityCreateButton = function (props) {
  var entityTypeName = props.entityTypeName,
    className = props.className,
    iconSize = props.iconSize,
    isLabelShown = props.isLabelShown,
    params = props.params,
    children = props.children,
    rest = __rest(props, ["entityTypeName", "className", "iconSize", "isLabelShown", "params", "children"]);
  var definition = (0, use_entity_definition_named_1.useEntityDefinitionNamed)(entityTypeName);
  var paths = definition.paths,
    scopeSlug = definition.scopeSlug;
  var t = (0, use_lang_1.useLang)();
  var from = props.from;
  if (!entityTypeName) {
    throw new Error("Error: Entity Create Button cannot be rendered. Missing entity name");
  }
  var _trailing = "".concat(params).concat(from ? "/from".concat(from) : '');
  var ENTITY_CREATE = paths.create;
  if (!ENTITY_CREATE) {
    return null;
  }
  var modal = (0, use_modal_1.useModal)();
  var handleClick = function () {
    modal.show(React.createElement(My.CreateDialog, {
      entityTypeName: entityTypeName,
      onComplete: function () {
        modal.hide();
      },
      onCancel: function () {
        modal.hide();
      }
    }));
  };
  var handleClickLegacy = ENTITY_CREATE && function () {
    return (0, router_1.navigate)((0, route_1.route)(ENTITY_CREATE, {
      _trailing: _trailing
    }));
  };
  return (0, current_user_can_1.currentUserCan)(['write:any', "write:".concat(scopeSlug), "create:".concat(scopeSlug)]) && React.createElement(My.Container, __assign({}, rest, {
    iconSize: iconSize,
    className: className,
    onClick: handleClickLegacy
  }), isLabelShown && (children || (0, sprintf_js_1.sprintf)(t(definition.create.label), definition.label)));
};
exports.EntityCreateButton = EntityCreateButton;
exports.EntityCreateButton.defaultProps = exports.EntityCreateButtonDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;